(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shah-personal-help"]) return;
  try {
    
(() => {
const help=document.getElementById('shah-help');
if(!help)return;
const live=help.querySelector('.shah-help__live');
const status=help.querySelector('.shah-help__status');
const selector='[data-spec="toggle-button"],button.chat-toggle,.chat-app>button';
function roots(){
return [...document.querySelectorAll('inbox-online-store-chat,#ShopifyChat')].map(e=>e.shadowRoot).filter(Boolean);
}
function manage(){
for(const root of roots()){
const toggle=root.querySelector(selector);
if(toggle&&!root.querySelector('#shah-hide-launcher')){
const style=document.createElement('style');style.id='shah-hide-launcher';
style.textContent=selector+'{display:none!important}';root.append(style);
}
}
}
document.documentElement.classList.add('shah-chat-managed');
manage();
const watch=setInterval(manage,1000);
setTimeout(()=>clearInterval(watch),60000);
live.addEventListener('click',()=>{
status.hidden=true;
let button=roots().map(root=>root.querySelector(selector)).find(Boolean);
if(!button){
try{button=document.getElementById('dummy-chat-button-iframe')?.contentDocument?.getElementById('dummy-chat-button');}catch(e){}
}
if(button){
const expanded=button.getAttribute('aria-expanded')==='true';
if(!expanded)button.click();
help.open=false;
let count=0;const startup=setInterval(()=>{manage();if(++count>20)clearInterval(startup);},500);
}else{status.hidden=false;}
});
help.querySelector('.shah-help__close').addEventListener('click',()=>{help.open=false;help.querySelector('summary').focus();});
help.addEventListener('keydown',e=>{if(e.key==='Escape'){help.open=false;help.querySelector('summary').focus();}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t3dc-3d-preview-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-t3dc-preview]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const teaser = root.querySelector('[data-preview-teaser]');
      const dialog = root.querySelector('[data-preview-dialog]');
      const video = dialog?.querySelector('video');
      if (!teaser || !dialog) return;
      const delay = Number.parseInt(getComputedStyle(root).getPropertyValue('--preview-delay'), 10) || 5000;
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const mainCta = document.querySelector('.t3dc-home__copy .t3dc-home__button');
      let teaserReady = false;
      let mainCtaVisible = false;

      const setTeaserState = () => {
        const shouldHide = !teaserReady || (mobileQuery.matches && mainCtaVisible);
        if (shouldHide) {
          teaser.classList.remove('is-visible');
          teaser.hidden = true;
          return;
        }
        teaser.hidden = false;
        requestAnimationFrame(() => teaser.classList.add('is-visible'));
      };

      if (mainCta && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          mainCtaVisible = entries[0]?.isIntersecting === true;
          setTeaserState();
        }, { threshold: 0.01 });
        observer.observe(mainCta);
      }

      window.setTimeout(() => {
        teaserReady = true;
        setTeaserState();
      }, delay);

      root.querySelector('[data-preview-open]')?.addEventListener('click', () => {
        dialog.showModal();
        if (video) {
          video.currentTime = 0;
          video.load();
          video.play().catch(() => {});
        }
      });
      const closeDialog = () => {
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        dialog.close();
      };
      root.querySelector('[data-preview-close]')?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', () => {
        if (video) video.pause();
      });
      root.querySelector('[data-preview-dismiss]')?.addEventListener('click', () => {
        teaserReady = false;
        teaser.classList.remove('is-visible');
        teaser.hidden = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
